import { colors } from "theme/palette";

import DealAvatar from "components/DealAvatar";
import placeholderIcon from "components/DealAvatar/assets/default.png";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

const MemoTemplateMemoHeader = () => (
  <Paper
    sx={{
      backgroundColor: colors.blue10,
      borderRadius: 0,
    }}
  >
    <Stack direction="row" spacing={2}>
      <DealAvatar
        src={placeholderIcon}
        imgix
        imgixWidth={480}
        imgixHeight={240}
        sx={{
          width: "240px",
          height: "120px",
          objectFit: "cover",
        }}
      />
      <Stack>
        <Text variant="label" sx={{ color: colors.blue100 }}>
          Memo Title
        </Text>
        <Text variant="h1">Deal Name</Text>
      </Stack>
    </Stack>
  </Paper>
);
export default MemoTemplateMemoHeader;
